module.exports = __webpack_public_path__ + "img/ring_y_l_1_0@3x.bce1aa89.png";